<script setup lang="ts">
import { onMounted, onUnmounted, reactive, ref, watch } from "vue";
import {
  activeSpeakerId,
  endSpeakerMode,
  startSpeakerMode,
} from "../../../states/speakerModeState";
import OneVideo from "../../../components/OneVideo.vue";
import { getUserById } from "../../../states/usersState";
import { maxWH } from "../../../utils/appSizes";

const size = reactive({
  width: 160,
  height: 90,
});
const area = ref<HTMLElement | null>(null);
const speakers = reactive<
  { userId: string; avatar: string; displayedName: string }[]
>([]);
startSpeakerMode();
let observer: ResizeObserver | null = null;
onMounted(() => {
  recalculateSize();
  observer = new ResizeObserver(recalculateSize);
  observer.observe(area.value!);
  watch(
    () => activeSpeakerId.value,
    (next, prev) => {
      if (next && next !== prev) {
        const user = getUserById(next);
        if (user)
          speakers.unshift({
            userId: user.id,
            avatar: user.avatar || "",
            displayedName: user.displayedName,
          });
        setTimeout(() => {
          if (speakers.length > 1) {
            speakers.pop();
          }
        }, 1300);
      }
    },
    { immediate: true },
  );
});
function recalculateSize() {
  if (area.value) {
    const news = maxWH(
      area.value.clientWidth - 48,
      area.value.clientHeight - 48,
    );
    news.width = Math.floor(news.width);
    news.height = Math.floor(news.height);
    Object.assign(size, news);
  }
}

onUnmounted(() => {
  endSpeakerMode();
  window.removeEventListener("resize", recalculateSize);
  observer?.disconnect();
});
</script>
<template>
  <div ref="area" class="video-area">
    <TransitionGroup name="fade">
      <OneVideo
        v-for="(s, idx) in speakers"
        :user-id="s.userId"
        :avatar="s.avatar"
        :displayed-name="s.displayedName"
        :size="size"
        :key="s.userId"
        class="one-item"
        :style="{
          'z-index': idx,
        }"
      />
    </TransitionGroup>
  </div>
</template>
<style scoped>
video {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  width: 100%;
  border-radius: 8px;
}

.video-area {
  height: 100%;
  width: 100%;
  padding: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  position: relative;
}

.one-item {
  position: absolute;
}
</style>
<style>
.fade-leave-active {
  transition: opacity 120ms ease-in;
}

.fade-leave-to {
  opacity: 0;
}
</style>
